/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EnvironmentEntryInput,
  EnvironmentEntryInput$Outbound,
  EnvironmentEntryInput$outboundSchema,
} from "./environmententryinput.js";

/**
 * Form for creating a new environment
 */
export type CreateEnvironmentForm = {
  /**
   * Optional description of the environment
   */
  description?: string | undefined;
  /**
   * List of environment variable entries
   */
  entries: Array<EnvironmentEntryInput>;
  /**
   * The name of the environment
   */
  name: string;
  /**
   * The organization ID this environment belongs to
   */
  organizationId: string;
};

/** @internal */
export type CreateEnvironmentForm$Outbound = {
  description?: string | undefined;
  entries: Array<EnvironmentEntryInput$Outbound>;
  name: string;
  organization_id: string;
};

/** @internal */
export const CreateEnvironmentForm$outboundSchema: z.ZodMiniType<
  CreateEnvironmentForm$Outbound,
  CreateEnvironmentForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    entries: z.array(EnvironmentEntryInput$outboundSchema),
    name: z.string(),
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
    });
  }),
);

export function createEnvironmentFormToJSON(
  createEnvironmentForm: CreateEnvironmentForm,
): string {
  return JSON.stringify(
    CreateEnvironmentForm$outboundSchema.parse(createEnvironmentForm),
  );
}
